(function () {

    "use strict";

    function officePublicService($http, $q) {

        var self = this;
        
        self.canBeOpenedWithOffice = function (idbox, iddocument, action, idUrl, hash, password) {
            var parametros = idbox + '/' + iddocument + '/' + action;
            var securityParams = '/' + idUrl + '/' + hash + '/' + password;
            var url = '/public/office/canview/' + parametros + securityParams;
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(function (response) {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(function (error) {
                    console.error(error);
                    reject();
                });
            });
        };

        self.canBeOpenedWithOfficeDocumentary = function (idFileContainer, idFileItem, action, idUrl, hash, password) {
            var parametros = idFileContainer + '/' + idFileItem + '/' + action;
            var securityParams = '/' + idUrl + '/' + hash + '/' + password;
            var url = '/public/office/canview/documentary/' + parametros + securityParams;
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(function (response) {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(function (error) {
                    console.error(error);
                    reject();
                });
            });
        };

        self.openWithOffice = function (idbox, iddocument, token, action, idUrl, hash, password, canprint) {

            if (token.length === 0)
            {
                token = 'empty_token';
            }            
            var parametros = idbox + '/' + iddocument + '/' + token + '/' + action;
            var securityParams = '/' + idUrl + '/' + hash + '/' + password;
            var url = '/public/office/link/' + parametros + securityParams + '?canprint=' + canprint;
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(function (response) {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(function (error) {
                    console.error(error);
                    reject();
                });
            });
        };

        self.openWithOfficeDocumentary = function (idbox, iddocument, token, action, idUrl, hash, password, canprint) {

            if (token.length === 0) {
                token = 'empty_token';
            }
            var parametros = idbox + '/' + iddocument + '/' + token + '/' + action;
            var securityParams = '/' + idUrl + '/' + hash + '/' + password;
            var url = '/public/office/link/documentary/' + parametros + securityParams + '?canprint=' + canprint;
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(function (response) {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(function (error) {
                    console.error(error);
                    reject();
                });
            });
        };

        self.getUrlAppViewer = function (idUrl, hash, password) {
            var securityParams = '/' + idUrl + '/' + hash + '/' + password;
            var url = '/public/office/getconfiguration' + securityParams;
            return $q(function (resolve, reject) {
                $http.get(url, { cache: true }).then(function (response) {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(function (error) {
                    console.log(error);
                    reject();
                });
            });
        };
    }

    officePublicService.$inject = ["$http", "$q"];

    angular.module("solpheo").service("solpheo.officePublicService", officePublicService);

})();